import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoadingService } from '@gs-2.0/shared';
import { AuthService } from '../services/auth.service';

export const ssoLoginGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loadingService = inject(LoadingService);
  const returnUrl: string = route.queryParams['returnUrl'] || '';

  if (authService.hasValidToken()) {
    return router.createUrlTree([returnUrl || authService.getLandingRoute()]);
  }

  loadingService.show({ messageKey: 'common.loading.initializingApp', indeterminate: true, showProgress: false });
  authService.login(returnUrl || undefined);
  return false;
};
